import React from 'react';
import PropTypes from 'prop-types';

import Carousel, { Slide } from '../../../../library/carousel/carousel';
import CmsFeatureArticle from './components/cms-featured-article/cms-featured-article';

import './cms-featured-article-list.scss';

function CmsFeaturedArticleList(props) {
  const { articles } = props;

  return (
    <div styleName="container">
      <div styleName="article-list">
        {Array.isArray(articles) &&
          articles.map((props, idx) => (
            <CmsFeatureArticle isFixedWidth key={`cfal-${idx}`} {...props} />
          ))}
      </div>

      <div styleName="article-carousel">
        <Carousel hasFullWidthSlides showIndicators>
          {Array.isArray(articles) &&
            articles.map((props, idx) => (
              <Slide key={`cfac-${idx}`}>
                <CmsFeatureArticle {...props} />
              </Slide>
            ))}
        </Carousel>
      </div>
    </div>
  );
}

CmsFeaturedArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      heading: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.object,
      link: PropTypes.object
    })
  )
};

export default CmsFeaturedArticleList;
